import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Total Necessity Actions Cell Renderer Component
 *
 * Cell renderer for actions column in total-necessity component.
 * Shows "Ver clientes" and "Ver pedidos" buttons.
 */
@Component({
  selector: 'app-total-necessity-actions-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule],
  template: `
   <div class="text-right flex items-right justify-start">
      <button mat-icon-button color="primary" matTooltip="Ver clientes"
          (click)="onOpenMaterial()">
        <mat-icon>person_search</mat-icon>
      </button>
      <button mat-icon-button color="accent" matTooltip="Ver pedidos"
          (click)="onGoToOrder()" class="ml-2">
        <mat-icon>arrow_outward</mat-icon>
      </button>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class TotalNecessityActionsCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  onOpenMaterial(): void {
    if (this.params?.onOpenMaterial) {
      this.params.onOpenMaterial(this.params.data);
    }
  }

  onGoToOrder(): void {
    if (this.params?.onGoToOrder) {
      this.params.onGoToOrder(this.params.data);
    }
  }
}
